export default __webpack_public_path__ + "static/Sipi-773e9a7578d8417b789414fd6d587d9f.jpg";